import { Box, Text } from '@chakra-ui/react';

const ElementErrorMessage = ({ props, qid } ) => {
  if ( Object.keys(props.stateProps.asError).length > 0) {
    return (
      <Box sx={{ margin: ['0', '0 0 0 16px'], textAlign: ['center', 'left'] }}>
        <Text variant="errorMessage">
          {props.stateProps.asError[qid]}
        </Text>
      </Box>
    );
  } else {
    return null;
  }
};

export default ElementErrorMessage;
